<h2 mat-dialog-title>{{'btn_edit' | translate}} ({{ userCount }})</h2>

<mat-dialog-content>
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{'LINK.UserGroup' | translate}}</mat-label>
    <mat-select [(ngModel)]="groupId">
      <mat-option *ngFor="let g of groups" [value]="g.identifier">{{ g.name }}</mat-option>
    </mat-select>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">{{'gen_dialog_btn_cancle' | translate}}</button>
  <button mat-button class="main-button" [disabled]="!groupId || saving" (click)="confirm()">
    {{'FORM.BTN_SAVE' | translate}}
  </button>
</mat-dialog-actions>
